module.exports = __webpack_public_path__ + "img/background.b06bdaba.svg";